module.exports = __webpack_public_path__ + "static/teleco_4-f8e858f31095b4366c81ab19e38199a6.jpg";